import * as moment from 'moment';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Component, OnInit, TemplateRef, ViewChild, Input} from '@angular/core';

import {LOCALE_CONFIG} from '@common-lib';
import {ConfigurationService, ProductsService, TranslationsService} from '../../pages-services';

@Component({
    selector: 'app-export-button',
    templateUrl: 'export-button.component.html',
    styleUrls: ['export-button.component.scss']
})
export class ExportButtonComponent implements OnInit {
    @Input() selectedLocale = LOCALE_CONFIG.DEFAULT_LOCALE;
    @Input() productsToExport: any[] = [];

    locales = [];
    products = [];
    showPrice = true;

    isExporting;

    exportSettingsModalRef: BsModalRef;

    @ViewChild('exportSettingsFormTemplate')
    exportSettingsFormTemplate: TemplateRef<any>;

    constructor(private modalService: BsModalService,
                private toasterService: ToasterService,
                private productsService: ProductsService,
                private translateService: TranslateService,
                private translationsService: TranslationsService,
                private configurationService: ConfigurationService) {
    }

    ngOnInit() {
        this.translationsService.getLocalizations().subscribe((data) => {
            this.locales = data.reduce((acc, cur, i) => {
                cur.locales.forEach((locale) => {
                    acc = [...acc, {
                        localeName: locale,
                        languageCode: cur.language,
                        languageTitle: cur.title,
                    }];
                });
                return acc;
            }, []);
        });

        this.productsService.getList(this.selectedLocale).subscribe(({products}) => this.products = products);

    }

    openExportSettingsDialog() {
        this.exportSettingsModalRef = this.modalService.show(this.exportSettingsFormTemplate);
    }

    closeExportSettingsDialog() {
        this.exportSettingsModalRef.hide();
        this.selectedLocale = LOCALE_CONFIG.DEFAULT_LOCALE;
    }

    saveFile() {
        this.isExporting = true;
        this.configurationService.getExport(this.productsToExport, this.showPrice, this.selectedLocale).subscribe(response => {
            this.saveToFileSystem(response);
            this.exportSettingsModalRef.hide();
        });
    }

    private async saveToFileSystem(response) {
        const fileContent = JSON.stringify(response, null, 2);
        const blob = new Blob([fileContent], {type: 'text/plain'});
        saveAs(blob, 'configurator-' + moment().format('YYYYMMDD-HHmm') + '.json');
        this.isExporting = false;
        const successMessage = await this.translateService.get('webpanel.products.export.success_message').toPromise();
        this.toasterService.pop('success', '', successMessage);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/export-button/export-button.component.ts